<template>
  <div class="content">
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/nav_img1.jpg" />
    </div>
    <div class="main">
      <div style="margin-top: 1rem;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/DecorationCase' }">装修案例</el-breadcrumb-item>
          <el-breadcrumb-item>装修案例详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="userinfo">
        <div class="userinfo-title">装修案例信息</div>
        <hr />
        <div class="userinfo-left">
          <div class="bran-father1">
            <img :src="dochd.mainpicmax" alt />
            <div class="brand1">桔家云</div>
          </div>
        </div>
        <div class="userinfo-right">
          <div>
            姓名:
            <span class="username">{{dochd.cnname}}先生</span>
          </div>
          <div>
            地址:
            <span class="username">{{dochd.cnaddress}}</span>
          </div>
          <div>
            户型:
            <span
              class="username"
            >{{dochd.roomnum}}{{dochd.meetnum}}{{dochd.toiletnum}}{{dochd.kitchennum}}</span>
          </div>
          <div>
            风格:
            <span class="username">{{dochd.style}}</span>
          </div>
          <div>
            面积:
            <span class="username">{{dochd.cnareanum}}㎡</span>
          </div>
          <div>
            费用:
            <span class="username">¥{{dochd.totalmoney}}</span>
          </div>
        </div>
      </div>
      <div class="center1">
        <div class="center1-left">
          案例详情
        </div>
      <div class="center1-right">
      </div>
      </div>
      <div class="main-img" v-for="(item,index) in datas.item" :key="index">
        <div class="main-title">{{item.sname}}</div>
        <div v-for="(ites,index) in item.detailitem" :key="index">
          <div class="bran-father">
            <img :src="ites.imagemax" oncontextmenu="return false;" />
            <div class="brand">桔家云</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:3rem;"></div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
export default {
  components: {
  
    BottomFoot,
    Rightnav,
    Freequote
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、装修案例、装修参考、整装、婚房、单身公寓、装修效果图、100平、三口之家、儿童房桔家云整装，上千个装修案例实景分享，业主精心总结装修攻略，新中式、简欧、美式等各种风格案例，尽在桔家云整装。"
        }
      ]
    };
  },
  data() {
    return {
      showquote: false,
      topnub: 0,
      nub: "3",
      current: 0,
      datas: "",
      dochd: ""
    };
  },
  methods: {
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    postdetails: async function() {
      let id = this.$route.query.id;
      let data = {
        docid: id
      };
      let res = await this.exequy.decorations(data);
      this.datas = res.data.data;
      this.dochd = res.data.data.dochd;
    }
  },
  created: async function() {
    let self = this;
    self.postdetails();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.username {
  color: #9b9b9b;
}
.userinfo {
  width: 850px;
  margin: 0 auto;
  margin-top: 2rem;
  margin-bottom: 3rem;
  text-align: left;
  border: 1px solid #bbb8b8;
  padding: 8px;
  overflow: hidden;
}
.center1{
  width: 868px;
  margin: 0 auto;
  height: 75px;
}
.center1-left{
  float: left;
  height: 50px;
  width: 20%;
  color: #b31d25;
  font-size: 17px;
  line-height: 50px;
  border:1px solid rgb(189, 189, 189);
  border-top: 3px solid #b31d25;
}
.center1-right{
  float: left;
  height: 52px;
  width: 79.5%;
  border:1px solid rgb(189, 189, 189);
  border-left: none;
}
.userinfo hr {
  border: 0.5px solid rgb(165, 165, 165);
}
.userinfo-title {
  font-size: 25px;
  /* border-bottom: 1px solid #bbb8b8; */
  margin-bottom: 10px;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}

.main {
  width: 1340px;
  margin: 0 auto;
}
.banane {
  width: 100%;
  height: 340px;
  
}

.banane img {
  width: 100%;
  height: 100%;
}
.main >>> .el-breadcrumb {
  font-size: 15px;
}
.main-img {
  width: 100%;
}
.main-img img {
  width: 850px;
  height: 540px;
}
.bran-father {
  position: relative;
}
.brand {
  width: 12%;
  height: 50px;
  background: #b31d25;
  position: absolute;
  top: 0px;
  right: 18.2%;
  color: #fff;
  line-height: 50px;
  font-size: 25px;
}
.bran-father1 {
  position: relative;
}
.brand1 {
  width: 21%;
  height: 35px;
  background: #b31d25;
  position: absolute;
  top: 0px;
  right: 0;
  color: #fff;
  line-height: 35px;
  font-size: 21px;
  text-align: center;
}
.main-title {
  /* text-align: left; */
  padding-top: 2rem;
  font-size: 32px;
  width: 850px;
  margin: 0 auto;
  padding-bottom: 1.5rem;
}
.userinfo-left {
  width: 50%;
  float: left;
}
.userinfo-left img {
  width: 100%;
  height: 240px;
}
.userinfo-left div,
.userinfo-right div {
  margin-bottom: 8px;
}
.userinfo-right {
  width: 44%;
  float: left;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 4%;
}
</style>
